/** Site branding — swap when a cleared domain/name is chosen. */
export const brand = {
  name: 'BoozeRatio',
  tagline: 'Compare alcohol, calories, and cost.',
  domain: 'BoozeRatio.com',
  /** Absolute site origin for canonical URLs, sitemap, and Open Graph (no trailing slash). */
  siteUrl: 'https://boozeratio.com',
  contactEmail: 'feedback@boozeratio.com',
  positioning:
    'Ratios compare composition and value — not health, taste, or predicted intoxication.',
  adultNotice: 'For adults of legal drinking age. Drink responsibly.',
} as const;

export type BrandConfig = typeof brand;
